@if (authenticated()) {
    <aside [attr.aria-label]="'aria.sidemenu.complementary' | translate" role="complementary">
        <nav
            id="sidemenu"
            class="sidemenu scroll scroll2"
            [class.sidemenu--small]="!isSidemenuVisible() || categoryContainerState === CATEGORY_CONTAINER_STATE.OPENED"
            [class.sidemenu--inmobile]="inmobile"
            [class.sidemenu--is-mobile-size]="isMobileSize"
            [class.sidemenu--open-mobile-size]="openedMenuMobileSize()"
            role="navigation"
            [attr.aria-label]="'aria.sidemenu.main' | translate">
            @for (link of menuLinks; track link) {
                <button
                    type="button"
                    [attr.id]="link.id"
                    class="sidemenu__item {{link.class}}"
                    [class.sidemenu__item--selected]="checkActive(link)"
                    [class.sidemenu__item--disabled]="!link.isAccessible"
                    (click)="redirectTo(link.url)"
                    tabindex="0"
                    role="menuitem"
                    [attr.aria-current]="checkActive(link) ? 'page' : null"
                    [attr.aria-disabled]="!link.isAccessible ? 'true' : null">
                    <span class="sidemenu__icon icon" [class]="link.icon" aria-hidden="true"></span>
                    <span class="sidemenu__label" [translate]="link.title"></span>
                    @if (!link.isAccessible) {
                        <span class="sidemenu__locked icon icon-state-locked margin-left-auto" aria-hidden="true"></span>
                    }
                    @if (link.beta) {
                        <span class="sidemenu__beta">beta</span>
                    }
                </button>
            }
            @if (isSideMenuMoreItemVisible) {
                <button
                    type="button"
                    id="menu-more"
                    class="sidemenu__item sidemenu__item--bottom"
                    [class.sidemenu__item--selected]="checkActiveMenuMore()"
                    (click)="toggleSubmenuVisibility()"
                    role="menuitem">
                    <span class="sidemenu__icon icon icon-menu-more"></span>
                    <span class="sidemenu__label" [translate]="'global.navbar.more'"></span>
                </button>
            }
            <!-- Este if no está funcionando ni en Backoffice NG13, comentar hasta ver -->
            <!-- @if (categoryContainerState != CATEGORY_CONTAINER_STATE.OPENED || _rootScope.currentRoute?.originalPath != '/knowledge-center') { -->
            <div class="sidemenu__arrows-container">
                @if (!inmobile && (isSidemenuVisible() || !openedMenuMobileSize())) {
                    <button
                        type="button"
                        class="sidemenu__arrow icon"
                        [class]="isSidemenuVisible() ? 'icon-arrow-left' : 'icon-arrow-right'"
                        (click)="isSidemenuVisible() ? closeSidemenu() : openSidemenu()"
                        tabindex="0"
                        [attr.aria-label]="isSidemenuVisible() ? ('aria.sidemenu.close' | translate) : ('aria.sidemenu.open' | translate)"></button>
                }
            </div>
            <!-- } -->
            @if (isSubmenuVisible && submenuLinks.length > 0) {
                <div
                    class="sidemenu sidemenu__submenu"
                    role="menu"
                    [class.sidemenu__submenu--from-small]="!isSidemenuVisible() || categoryContainerState === CATEGORY_CONTAINER_STATE.OPENED || (isMobileSize && !openedMenuMobileSize())">
                    @for (link of submenuLinks; track link) {
                        <button
                            type="button"
                            [attr.id]="link.id"
                            class="sidemenu__item {{link.class}}"
                            [class.sidemenu__item--selected]="checkActive(link)"
                            [class.sidemenu__item--disabled]="!link.isAccessible"
                            (click)="redirectTo(link.url)"
                            role="menuitem"
                            tabindex="0"
                            [attr.aria-current]="checkActive(link) ? 'page' : null"
                            [attr.aria-disabled]="!link.isAccessible ? 'true' : null">
                            <span class="sidemenu__icon" [class]="link.icon" aria-hidden="true"></span>
                            <span class="sidemenu__label" [translate]="link.title"></span>
                            @if (!link.isAccessible) {
                                <span class="sidemenu__locked icon icon-state-locked margin-left-auto" aria-hidden="true"></span>
                            }
                        </button>
                    }
                </div>
            }
        </nav>
        <div
            class="sidemenu__overlay"
            (click)="closeSidemenu()"
            (keydown)="($event.key === 'Enter' || $event.key === ' ') && closeSidemenu()"
            tabindex="0"
            [attr.aria-label]="'aria.sidemenu.close' | translate"></div>
    </aside>
}
